import React from 'react';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Categories } from '../../../../../Utils/Types/Posts';
import usePostsInfiniteQuery from '../../../../../Hooks/usePostsInfiniteQuery';
import ChildrenList from './ChildrenList';
import Loader from './Loader';
import { PostVisibilities } from '../../../../../Utils/Types';

const POSTS_LIMIT = 6;

function SubContent({ post, space }: any) {
  const consultationsListWithMetadata = usePostsInfiniteQuery(Categories.CONSULTATION.join('-'), {
    post,
    parentId: post.id,
    limit: POSTS_LIMIT,
    space,
    types: Categories.CONSULTATION,
    visibilities: [PostVisibilities.PUBLISHED],
  });

  const newsListWithMetadata = usePostsInfiniteQuery(Categories.COMMUNICATION.join('-'), {
    post,
    parentId: post.id,
    limit: POSTS_LIMIT,
    visibilities: [PostVisibilities.PUBLISHED],
    types: Categories.COMMUNICATION,
    space,
  });

  const postsCount = consultationsListWithMetadata.postsCount + newsListWithMetadata.postsCount;
  const isLoading = consultationsListWithMetadata.isFetching || newsListWithMetadata.isFetching;

  if (isLoading && !postsCount) return <Loader />;

  return (
    <>
      {postsCount > 0 && (
        <>
          <Box sx={{ mb: 3 }}>
            <ChildrenList
              postsListWithMetadata={consultationsListWithMetadata}
              parent={post}
              label={
                <FormattedMessage
                  id="POSTS.CONSULTATIONS.CONSULTATIONS_COUNT"
                  values={{ count: consultationsListWithMetadata.postsCount }}
                />
              }
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <ChildrenList
              postsListWithMetadata={newsListWithMetadata}
              parent={post}
              label={
                <FormattedMessage
                  id="POSTS.CONSULTATIONS.NEWS_COUNT"
                  values={{ count: newsListWithMetadata.postsCount }}
                />
              }
            />
          </Box>
        </>
      )}
    </>
  );
}

SubContent.propTypes = {
  post: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  space: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default SubContent;
